import defaultTheme from '../../../../theme/defaultTheme';
import {
  DRAWER_BREAK_POINT,
  HEADER_TYPE,
  LAYOUT_STYLES,
  LAYOUT_TYPES,
  SIDEBAR_TYPE,
  SIDEBAR_WIDTH,
  THEME_TYPES,
} from '../../../constants/ThemeOptions';

export default {
  theme: defaultTheme,
  defaultLng: {
    languageId: 'twchinese',
    locale: 'tw',
    name: 'Taiwan',
    icon: 'tw',
  },
  layout: LAYOUT_TYPES.VERTICAL_DEFAULT,
  //layout: LAYOUT_TYPES.VERTICAL_MINIMAL,
  //layout: LAYOUT_TYPES.VERTICAL_MINIMAL_NO_HEADER,
  //layout: LAYOUT_TYPES.VERTICAL_MODERN_SIDEBAR,
  //layout: LAYOUT_TYPES.HORIZONTAL_DEFAULT,
  //layout: LAYOUT_TYPES.HORIZONTAL_DARK,
  //layout: LAYOUT_TYPES.HORIZONTAL_MINIMAL,
  //layout: LAYOUT_TYPES.HORIZONTAL_TOP_MENU,
  layoutType: LAYOUT_STYLES.FULL_WIDTH,
  themeType: THEME_TYPES.LIGHT,
  //themeType: THEME_TYPES.DARK,
  //themeType: THEME_TYPES.SEMI_DARK,
  drawerBreakPoint: DRAWER_BREAK_POINT.MD,
  headerType: HEADER_TYPE.FIXED,
  sidebarType: SIDEBAR_TYPE.FULL,
  isSidebarFixed: true,
  sidebarWidth: SIDEBAR_WIDTH.DEFAULT,
  showFooter: false,
};
